import { getDataLayerTimestamp } from './dataLayerTimestamp';
import { pushToDataLayer } from './pushToDataLayer';
import { activeCampaignVariant } from '@/lib/activeCampaign';

// Same value as DEPLOYMENT_ENVIRONMENT (see lib/domain-config.ts), but
// NEXT_PUBLIC_-prefixed so it's readable from client-side code — pushGaEvent
// runs in the browser, where DEPLOYMENT_ENVIRONMENT itself is never inlined.
const isProdEnvironment = (): boolean =>
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'prod';

// Static fields merged into every pushed event, configured via the
// NEXT_PUBLIC_EXTRA_FIELDS build-time env/docker variable as a JSON object
// (e.g. `NEXT_PUBLIC_EXTRA_FIELDS={"tenant":"sh-de"}`). NEXT_PUBLIC_-prefixed
// for the same reason as isProdEnvironment above — this runs in the browser.
// Unset, empty, or malformed JSON simply disables the feature (no extra
// fields added) rather than throwing.
const getEnvExtraFields = (): Record<string, unknown> => {
  const raw = process.env.NEXT_PUBLIC_EXTRA_FIELDS;
  if (!raw) {
    return {};
  }

  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed !== null &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : {};
  } catch {
    return {};
  }
};

export const pushGaEvent = (
  extraFields: Record<string, unknown> = {},
  event = 'ga_event',
): void => {
  const dataLayerEvent = {
    ...getEnvExtraFields(),
    event,
    campaign_variant: activeCampaignVariant(),
    ...extraFields,
    ...getDataLayerTimestamp(),
  };

  if (!isProdEnvironment()) {
    console.log('[pushGaEvent]', dataLayerEvent);
  }

  pushToDataLayer(dataLayerEvent);
};
